import { Typography } from '@mui/material';
import React from 'react';

interface MachineComponentItem {
    value: string;
}
interface MachineComponentListProps {
    header: string;
    items: MachineComponentItem[];
}

export const MachineComponentList: React.FC<MachineComponentListProps> = ({ header, items }) => (
    <div style={styles.container}>
        <Typography variant="subtitle1" style={styles.header}>
            {`${header || ''} Components`}
        </Typography>
        <div style={styles.itemsContainer}>
            {items.map((item, index) => (
                <Typography key={index}>{`\n${index + 1}. ${item?.value}`}</Typography>
            ))}
        </div>
    </div>
);

const styles = {
    container: {
        backgroundColor: '#F7F8F8',
        padding: '10px',
        borderRadius: '4px',
        marginBottom: '20px',
    },
    header: {
        marginBottom: '0',
    },
    itemsContainer: {
        padding: 10,
        marginLeft: 10,
    },
};
